<template>
  <Modal
    :active="true"
    class="auto-allocation-modal"
    size="medium"
    @onClose="onClose()">
    <div slot="header" class="auto-allocation-modal__header">
      <div class="auto-allocation-modal__header__title-left-area">
        <p>Auto Allocation status</p>
      </div>
    </div>
    <template #content>
      <div class="auto-allocation-modal__container">
        <div
          class="auto-allocation-modal__container__validation-msg"
          v-html="autoAllocationStatus"></div>
      </div>

      <div v-if="isLoading">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
          color="#0573ab" />
      </div>
    </template>
    <template v-if="showCountDownTimer" slot="footer">
      <div class="modal__footer">
        <count-down-timer
          :is-refresh-button-disabled="isRefreshButtonDisabled"
          :refresh-time-interval="5"
          @updateRefreshButtonDisabledFlag="updateRefreshButtonDisabledFlag"
          @fetchDisputeDetailsByBulkIds="getAutoAllocationStatus">
        </count-down-timer>
      </div>
    </template>
  </Modal>
</template>

<script>
// Helpers
import { getMsalIdToken } from "@/utils/helpers.js";
// Custom Components
import CountDownTimer from "@/components/CountDownTimer/CountDownTimer.vue";
import Loading from "vue-loading-overlay";
// Utils
import AxiosFetchForMsal from "@/utils/axiosForMsal";
// Actions
import { disputeActions } from "@/actions";
export default {
  name: "AutoAllocationStatusModal",
  components: {
    CountDownTimer,
    Loading,
  },
  data() {
    return {
      autoAllocationStatus: "Inprogress",
      isLoading: false,
      isRefreshButtonDisabled: true,
    };
  },
  computed: {
    showCountDownTimer() {
      return this.autoAllocationStatus.includes("Inprogress");
    },
  },
  mounted() {},
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onConfirm() {},
    updateRefreshButtonDisabledFlag() {
      this.isRefreshButtonDisabled = false;
    },
    async getAutoAllocationStatus() {
      try {
        this.isLoading = true;
        const {
          idTokenClaims: { EmployeeID: employeeId },
        } = this.$store.getters.getTokenData;

        const { data } = await AxiosFetchForMsal(
          disputeActions.getAutoAllocateStatus(
            employeeId,
            await getMsalIdToken(this)
          )
        );
        this.autoAllocationStatus = data?.replaceAll(",", "<br/>");
        if (!this.isRefreshButtonDisabled) {
          this.isRefreshButtonDisabled = true;
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.auto-allocation-modal {
  .modal--medium {
    height: fit-content;
    width: 800px;
  }
  .modal__header {
    padding-bottom: 14px;
  }
  &__container {
    padding: 0px;
    &__validation-msg {
      padding-bottom: 8px;
    }
  }
  &__header {
    display: flex;
  }
  .modal__footer {
    z-index: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
